<template>
    <v-dialog
        scrollable
        :content-class="fixed ? 'fixed-dialog rounded-lg' : 'rounded-lg'"
        :value="value"
        :width="width"
        persistent
        :fullscreen="$vuetify.breakpoint.smAndDown"
        @input="closeDialog($event)"
    >
        <template v-slot:activator="{ on }">
            <slot name="activator" :on="on" />
        </template>
        <v-card class="dialog-card">
            <slot name="header-toolbar">
                <v-toolbar flat class="flex-grow-0" :class=[className]>
                  <v-toolbar-title class="w-100" :class="[textColor ,'px-2']">
                      <v-row class="ml-0 mr-0 dialog-title">
                          <v-img v-if="showLogo"
                            max-width="24px"
                            height="32.24px"
                            class="mr-3"
                            contain
                            src="@/assets/uku-icon.svg"
                          />
                       <slot name="header">
                          <span :class="[textColor,'font-weight-medium']" v-html="headerText"></span> <!-- ALL HEADERS SHOULD BE STATIC TRANSLATIONS -->
                       </slot>
                    </v-row>
                 </v-toolbar-title>
                  <v-spacer />
                  <v-btn v-if="!hideCloseIcon" icon @click="closeDialog(false)">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
            </slot>
            <div
                v-if="$slots.topBar"
                class="px-6"
            >
                <slot name="topBar" />
            </div>

            <ScrollShadow>
                <v-card-text :class="['dialog-content pb-0', actualFullContentWidth ? 'pa-0' : fullContentWidth ? 'pa-0 px-6' : 'px-6']">
                    <slot />
                </v-card-text>
            </ScrollShadow>
            <slot name="footer-toolbar">
                <v-card-actions
                    v-if="!hideFooter && $slots.footer"
                    class="px-6 py-3"
                    :class="[actionsRightAlign ? 'actions-bar-right-align' : 'dialog-actions-bar']"
                >
                    <slot name="footer" />
                </v-card-actions>
            </slot>
        </v-card>
    </v-dialog>
</template>

<script>
import ScrollShadow from "@/components/ScrollShadow.vue";

export default {
    name: "Dialog",
    components: {ScrollShadow},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        headerText: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            default: 500
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        actualFullContentWidth: {
            type: Boolean,
            default: false
        },
        fullContentWidth: {
            type: Boolean,
            default: false
        },
        hideCloseIcon: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        },
        className: {
            type: String,
            default: ""
        },
        showLogo: {
            type: Boolean,
            default: false
        },
        textColor: {
          type: String,
          default: ""
        },
        actionsRightAlign: {
          type: Boolean,
          default: false,
        }
    },
    setup(props, context) {
        const closeDialog = function(value) {
            if (!value) {
                context.emit("close_modal");
            }

            context.emit("input", value);
        };

        return {
            closeDialog
        };
    }
};
</script>
